import React from 'react';
import { Layout } from '../../components/Layout';
import { Card } from '../../components/ui/Card';
import { Button } from '../../components/ui/Button';
import { Badge } from '../../components/ui/Badge';
import { Container } from '../../components/ui/Container';
import { Section } from '../../components/ui/Section';
import { Target, Globe, Shield, Users, BookOpen, CheckCircle, ArrowRight } from 'lucide-react';
import { Link } from 'react-router-dom';
export function Mission() {
  return <Layout data-id="element-1025">
      <Section spacing="lg" data-id="element-1026">
        <Container size="lg" data-id="element-1027">
          {/* Hero */}
          <div className="mb-12 text-center animate-fade-in-up" data-id="element-1028">
            <Badge variant="primary" size="lg" className="mb-6" data-id="element-1029">
              Our Mission
            </Badge>
            <h1 className="text-4xl md:text-5xl lg:text-6xl font-bold text-slate-100 mb-6" data-id="element-1030">
              Mission & Vision
            </h1>
            <p className="text-lg md:text-xl text-slate-400 max-w-3xl mx-auto" data-id="element-1031">
              Building a safer digital world through education and empowerment.
              We believe cybersecurity is a fundamental right, not a privilege.
            </p>
          </div>

          <div className="grid lg:grid-cols-3 gap-8" data-id="element-1032">
            {/* Main Content */}
            <div className="lg:col-span-2 space-y-12" data-id="element-1033">
              {/* About CyberSecurityProtocol 101 - UPDATED */}
              <section className="animate-fade-in-up animation-delay-100" data-id="element-1034">
                <h2 className="text-2xl font-bold text-slate-100 mb-4 font-mono" data-id="element-1035">
                  About CyberSecurityProtocol 101
                </h2>
                <Card glass padding="lg" className="border-cyan-500/20" data-id="element-1036">
                  <div className="space-y-4 text-slate-300 leading-relaxed" data-id="element-1037">
                    <p data-id="element-1038">
                      <strong className="text-slate-100" data-id="element-1039">
                        CyberSecurityProtocol 101
                      </strong>{' '}
                      is a defensive, standards-aligned cybersecurity platform
                      designed to help{' '}
                      <strong className="text-cyan-400" data-id="element-1040">individuals</strong> and{' '}
                      <strong className="text-cyan-400" data-id="element-1041">organizations</strong>{' '}
                      assess risk, implement controls, and improve cyber
                      resilience.
                    </p>
                    <p data-id="element-1042">
                      The platform is built by{' '}
                      <span className="font-semibold text-cyan-400" data-id="element-1043">UXER</span>{' '}
                      and operates as part of{' '}
                      <span className="font-semibold text-slate-200" data-id="element-1044">
                        Asosiasi Teknologi Informasi & Open Source (ATIOS)
                      </span>
                      .
                    </p>
                    <p data-id="element-1045">
                      All content is{' '}
                      <strong className="text-emerald-400" data-id="element-1046">defensive</strong>,
                      lawful, and aligned with internationally recognized
                      cybersecurity standards and best practices.
                    </p>
                  </div>
                </Card>
              </section>

              {/* Target Audience - NEW */}
              <section className="animate-fade-in-up animation-delay-200" data-id="element-1047">
                <h2 className="text-2xl font-bold text-slate-100 mb-6 font-mono" data-id="element-1048">
                  Who We Serve
                </h2>
                <div className="grid sm:grid-cols-2 gap-4" data-id="element-1049">
                  <AudienceCard title="Individuals" icon={Users} data-id="element-1050" />
                  <AudienceCard title="Professionals" icon={Users} data-id="element-1051" />
                  <AudienceCard title="Companies" icon={Shield} data-id="element-1052" />
                  <AudienceCard title="NGOs" icon={Globe} data-id="element-1053" />
                  <AudienceCard title="Schools" icon={BookOpen} data-id="element-1054" />
                  <AudienceCard title="Institutions (non-state)" icon={Target} data-id="element-1055" />
                </div>
              </section>

              {/* Mission Statement - UPDATED */}
              <section className="animate-fade-in-up animation-delay-300" data-id="element-1056">
                <h2 className="text-2xl font-bold text-slate-100 mb-4 font-mono" data-id="element-1057">
                  Mission Statement
                </h2>
                <Card glass padding="lg" className="border-l-4 border-cyan-500" data-id="element-1058">
                  <p className="text-slate-300 text-lg leading-relaxed" data-id="element-1059">
                    CyberSecurityProtocol 101 exists to democratize
                    cybersecurity knowledge and make institutional-grade
                    security accessible to everyone—from individuals to
                    organizations. We bridge the gap between complex technical
                    standards and practical implementation.
                  </p>
                </Card>
              </section>

              {/* Vision */}
              <section className="animate-fade-in-up animation-delay-400" data-id="element-1060">
                <h2 className="text-2xl font-bold text-slate-100 mb-4 font-mono" data-id="element-1061">
                  Our Vision
                </h2>
                <p className="text-slate-400 leading-relaxed" data-id="element-1062">
                  We envision a world where every person and organization has
                  the knowledge and tools to protect themselves against digital
                  threats. A world where security is built-in, not bolted on,
                  and where defensive capabilities outpace offensive threats.
                </p>
              </section>

              {/* Core Values */}
              <section className="animate-fade-in-up animation-delay-500" data-id="element-1063">
                <h2 className="text-2xl font-bold text-slate-100 mb-6 font-mono" data-id="element-1064">
                  Core Values
                </h2>
                <div className="grid sm:grid-cols-2 gap-6" data-id="element-1065">
                  <ValueCard title="Education First" desc="Knowledge is the strongest defense. We prioritize understanding over tools." icon={BookOpen} data-id="element-1066" />
                  <ValueCard title="Accessibility" desc="Security for all, regardless of budget or technical expertise." icon={Globe} data-id="element-1067" />
                  <ValueCard title="Practical Focus" desc="Actionable guidance over theoretical concepts. We focus on what works." icon={CheckCircle} data-id="element-1068" />
                  <ValueCard title="Standards-Based" desc="Aligned with global frameworks and industry best practices. We don't reinvent the wheel." icon={Shield} data-id="element-1069" />
                  <ValueCard title="Defensive Only" desc="Ethical security guidance. We do not teach offensive techniques." icon={Users} data-id="element-1070" />
                  <ValueCard title="Transparency" desc="Open about our limitations, sources, and governance." icon={Target} data-id="element-1071" />
                </div>
              </section>

              {/* What We Don't Do */}
              <section className="animate-fade-in-up animation-delay-600" data-id="element-1072">
                <h2 className="text-2xl font-bold text-slate-100 mb-6 font-mono" data-id="element-1073">
                  What We Don't Do
                </h2>
                <Card glass padding="lg" className="border-red-500/20" data-id="element-1074">
                  <ul className="space-y-3 text-slate-400" data-id="element-1075">
                    <li className="flex items-start" data-id="element-1076">
                      <span className="text-red-500 mr-2 font-bold" data-id="element-1077">✕</span>
                      We do NOT provide offensive hacking training or exploit
                      instructions.
                    </li>
                    <li className="flex items-start" data-id="element-1078">
                      <span className="text-red-500 mr-2 font-bold" data-id="element-1079">✕</span>
                      We do NOT host or link to leaked data or illegal content.
                    </li>
                    <li className="flex items-start" data-id="element-1080">
                      <span className="text-red-500 mr-2 font-bold" data-id="element-1081">✕</span>
                      We do NOT guarantee security (there are no silver
                      bullets).
                    </li>
                    <li className="flex items-start" data-id="element-1082">
                      <span className="text-red-500 mr-2 font-bold" data-id="element-1083">✕</span>
                      We do NOT replace professional security advice for
                      critical systems.
                    </li>
                    <li className="flex items-start" data-id="element-1084">
                      <span className="text-red-500 mr-2 font-bold" data-id="element-1085">✕</span>
                      We do NOT provide government or national security-level
                      guidance.
                    </li>
                  </ul>
                </Card>
              </section>
            </div>

            {/* Sidebar */}
            <div className="space-y-6" data-id="element-1086">
              <Card glass padding="lg" className="sticky top-24 animate-fade-in-up animation-delay-700" data-id="element-1087">
                <h3 className="text-lg font-bold text-slate-100 mb-4 font-mono" data-id="element-1088">
                  Quick Links
                </h3>
                <div className="space-y-2" data-id="element-1089">
                  <Link to="/about/mission" className="block p-2 rounded bg-cyan-500/10 text-cyan-400 font-medium border border-cyan-500/20" data-id="element-1090">
                    Mission & Vision
                  </Link>
                  <Link to="/about/scope" className="block p-2 rounded hover:bg-slate-800/50 text-slate-400 hover:text-cyan-400 transition-colors" data-id="element-1091">
                    Scope & Non-Guarantee
                  </Link>
                  <Link to="/about/standards" className="block p-2 rounded hover:bg-slate-800/50 text-slate-400 hover:text-cyan-400 transition-colors" data-id="element-1092">
                    Standards Mapping
                  </Link>
                  <Link to="/about/changelog" className="block p-2 rounded hover:bg-slate-800/50 text-slate-400 hover:text-cyan-400 transition-colors" data-id="element-1093">
                    Changelog
                  </Link>
                  <Link to="/about/contact" className="block p-2 rounded hover:bg-slate-800/50 text-slate-400 hover:text-cyan-400 transition-colors" data-id="element-1094">
                    Contact Us
                  </Link>
                </div>

                <div className="mt-8 pt-6 border-t border-slate-800" data-id="element-1095">
                  <h4 className="text-sm font-bold text-slate-400 uppercase mb-4 font-mono" data-id="element-1096">
                    Start Learning
                  </h4>
                  <Link to="/start" className="block w-full" data-id="element-1097">
                    <Button variant="primary" fullWidth data-id="element-1098">
                      Get Started <ArrowRight className="ml-2 h-4 w-4" data-id="element-1099" />
                    </Button>
                  </Link>
                </div>
              </Card>
            </div>
          </div>
        </Container>
      </Section>
    </Layout>;
}
function AudienceCard({
  title,
  icon: Icon
}: {
  title: string;
  icon: any;
}) {
  return <Card glass padding="md" className="flex items-center space-x-3" data-id="element-1100">
      <div className="h-10 w-10 rounded-lg bg-cyan-500/10 flex items-center justify-center text-cyan-400" data-id="element-1101">
        <Icon className="h-5 w-5" data-id="element-1102" />
      </div>
      <span className="font-semibold text-slate-200" data-id="element-1103">{title}</span>
    </Card>;
}
function ValueCard({
  title,
  desc,
  icon: Icon
}: {
  title: string;
  desc: string;
  icon: any;
}) {
  return <Card glass padding="md" data-id="element-1104">
      <div className="flex items-center mb-3" data-id="element-1105">
        <Icon className="h-5 w-5 text-cyan-400 mr-2" data-id="element-1106" />
        <h3 className="font-bold text-slate-200" data-id="element-1107">{title}</h3>
      </div>
      <p className="text-sm text-slate-400" data-id="element-1108">{desc}</p>
    </Card>;
}